'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _ = require('lodash');
var toastr = require('toastr');
var AdvancedHepModalGridValidationService = function AdvancedHepModalGridValidationService(configurationService, AdvancedHepGridConstants, featureToggleService, advancedHepCommonValidationService, configurationParametersAdvancedService) {
  var CABIN_CAPACITIES_FIELD_PREFIX = 'cabinCapacities';
  var INPUT_SOURCE_TYPES = {
    'ATPCO': ['BASE FARE', 'Q', 'QK'],
    'GDS': ['BASE FARE', 'YQ', 'YR', 'OTHER'],
    'WEB': ['BASE FARE', 'YQ', 'YR', 'OTHER']
  };
  var MAX_LOS_RANGES = 5,
    MIN_LOS_START = 0,
    MAX_LOS_END = 330;
  function getCabinCapacitiesFieldName(cabin) {
    return CABIN_CAPACITIES_FIELD_PREFIX + '-' + cabin;
  }
  function hasDuplicateEntryForTripTypeAndSource(newEntry, entry, field1, field2) {
    var newEntryValues = _.split(newEntry[field1], ',');
    var existingEntryValues = _.split(entry[field1], ',');
    var newEntryValues1 = _.split(newEntry[field2], ',');
    var existingEntryValues1 = _.split(entry[field2], ',');
    if (_.intersection(newEntryValues, existingEntryValues).length > 0) {
      return _.intersection(newEntryValues1, existingEntryValues1).length > 0;
    }
    return false;
  }
  function validateCurtainRuleModal(editedRows, allRows) {
    var isValid = true;
    var availableCabins = configurationService.getCabins();
    var lowestCabin = _.last(availableCabins);
    var higherCabin;
    _.forEach(allRows, function (row) {
      _.forEach(availableCabins, function (cabinName) {
        if (!_.isNil(row[getCabinCapacitiesFieldName(cabinName)]) && row[getCabinCapacitiesFieldName(cabinName)] !== '') {
          if (cabinName !== lowestCabin) {
            higherCabin = cabinName;
          }
        }
      });
    });
    _.forEach(editedRows, function (row) {
      var count = 0;
      _.forEach(availableCabins, function (cabinName) {
        if (!_.isNil(row[getCabinCapacitiesFieldName(cabinName)]) && row[getCabinCapacitiesFieldName(cabinName)] !== '') {
          if (cabinName !== higherCabin && cabinName !== lowestCabin) {
            isValid = false;
            toastr.error('Please enter only one other cabin other than the lowest cabin');
            return isValid;
          }
          count++;
        }
      });
      if (count < 2 && isValid) {
        isValid = false;
        toastr.error('Please enter values for at least two cabins');
        return isValid;
      }
    });
    return isValid;
  }
  function validateTodHubBanksModal(gridData) {
    var seqMap = _.keyBy(gridData, 'timeBandSequence');
    if (gridData.length === 0) {
      toastr.error('At least one bank is required');
      return false;
    }
    if (_.size(seqMap) !== gridData.length) {
      toastr.error('Duplicated banks');
      return false;
    }

    // 1+2+...+n == (n*(n+1))/2
    if (_.sumBy(gridData, 'timeBandSequence') !== gridData.length * (gridData.length + 1) / 2) {
      toastr.error('Banks must be continuous numbers that start with 1');
      return false;
    }
    if (seqMap[1].start !== 0) {
      toastr.error('First bank must start with 0');
      return false;
    }
    if (seqMap[gridData.length].end !== 1440) {
      toastr.error('The last bank must end with 1440');
      return false;
    }
    for (var i = 2; i <= gridData.length; i++) {
      if (seqMap[i - 1].end + 1 !== seqMap[i].start) {
        toastr.error('Overlapping or non-continuous banks');
        return false;
      }
    }
    return true;
  }
  var validateMetroMarketModal = function validateMetroMarketModal(editedRows, gridData) {
    var isValid = true;
    var columnsToCheck = ['neighborMarketOrigin', 'neighborMarketDestination'];
    _.forEach(editedRows, function (row) {
      if (advancedHepCommonValidationService.isDuplicate(row, gridData, columnsToCheck)) {
        isValid = false;
        toastr.error('Duplicate row added for Origin and Destination');
      }
    });
    return isValid;
  };
  function isCompetitorFareBrandInvalid(row) {
    return !_.isNil(row.competitorFareBrand) && !_.isEmpty(row.competitorFareBrand) && _.intersection(getCompetitorFareBrands(row.benchmarkCarrier), _.split(row.competitorFareBrand, ',')).length !== _.split(row.competitorFareBrand, ',').length;
  }
  function validateFOBusinessRulesModal(editedRows, allRows) {
    var isValid = true;
    _.forEach(editedRows, function (row) {
      if ((_.isEmpty(row.hostFareBrand) || _.isNil(row.hostFareBrand)) && !_.isNil(row.competitorFareBrand) && !_.isEmpty(row.competitorFareBrand)) {
        isValid = false;
        toastr.error('Host Fare Brand is missing');
      }
      if (_.isEmpty(row.benchmarkFareComponent) || _.isNil(row.benchmarkFareComponent)) {
        isValid = false;
        toastr.error('Benchmark component is missing');
      }
      if (isCompetitorFareBrandInvalid(row)) {
        isValid = false;
        toastr.error('Selected competitor fare brands are not applicable for ' + advancedHepCommonValidationService.constructKey(row, AdvancedHepGridConstants.FO_BUSINESS_RULE_KEY_VALUES));
      }
    });

    //group by Orig-Dest-Season-BenchmarkCarrier
    var businessRuleKeyValues = _.groupBy(allRows, function (row) {
      return advancedHepCommonValidationService.constructKey(row, AdvancedHepGridConstants.FO_BUSINESS_RULE_KEY_VALUES);
    });
    //check that none of key fields overlap
    for (var key in businessRuleKeyValues) {
      if (areBusinessRuleFieldsOverlapping(businessRuleKeyValues[key], key)) {
        isValid = false;
      }
    }
    return isValid;
  }
  function getCompetitorFareBrands(benchmarkCarrier) {
    return _.transform(configurationService.getFoFareBrandDefinitions(), function (result, current) {
      if (!_.isNil(benchmarkCarrier) && current.carrier === benchmarkCarrier) {
        _.forEach(_.chain(current.fareBrands).map('fareBrand').value(), function (fareBrand) {
          result.push(fareBrand);
        });
      } else if (_.isNil(benchmarkCarrier)) {
        _.forEach(_.chain(current.fareBrands).map('fareBrand').value(), function (fareBrand) {
          if (result.indexOf(fareBrand) === -1) {
            result.push(fareBrand);
          }
        });
      }
    });
  }
  function areBusinessRuleFieldsOverlapping(entries, key) {
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          var from = _.split(advancedHepCommonValidationService.constructKey(entries[i], AdvancedHepGridConstants.FO_BUSINESS_RULE_OVERLAPPING_FIELD_VALUES), '.');
          var to = _.split(advancedHepCommonValidationService.constructKey(entries[j], AdvancedHepGridConstants.FO_BUSINESS_RULE_OVERLAPPING_FIELD_VALUES), '.');
          if (_.intersection(_.split(from[0], ','), _.split(to[0], ',')).length > 0 && _.intersection(_.split(from[1], ','), _.split(to[1], ',')).length > 0 && _.intersection(_.split(from[2], ','), _.split(to[2], ',')).length > 0 && _.intersection(_.split(from[3], ','), _.split(to[3], ',')).length > 0 && _.intersection(_.split(from[4], ','), _.split(to[4], ',')).length > 0 && _.intersection(_.split(from[5], ','), _.split(to[5], ',')).length > 0) {
            toastr.error('Duplicate rows identified for ' + key);
            return true;
          }
        }
      }
    }
    return false;
  }
  function validateFOTaxOverride(editedRows, allRows) {
    var isValid = true;
    var columnsToCheck = ['fareType', 'fareTariffNumber', 'fareTypeIndicator'];
    _.forEach(editedRows, function (row) {
      if (advancedHepCommonValidationService.isDuplicate(row, allRows, columnsToCheck)) {
        isValid = false;
      }
    });
    if (!isValid) {
      toastr.error('Duplicate row added for fare type indicator, tariff and Tax/Surcharge Type.');
    }
    return isValid;
  }
  function validateFOCabinClassConfig(gridData) {
    var tacticalClassName = _.compact(_.chain(gridData).map(function (group) {
      if (group.category === 'TACTICAL') {
        return group.className.toUpperCase();
      }
    }).value());
    if (_.uniq(tacticalClassName).length !== tacticalClassName.length) {
      toastr.error('Class Name for Tactical Category must be unique.');
      return false;
    }
    var structuralClassName = _.compact(_.chain(gridData).map(function (group) {
      if (group.category === 'STRUCTURAL') {
        return group.className.toUpperCase();
      }
    }).value());
    if (_.uniq(structuralClassName).length !== structuralClassName.length) {
      toastr.error('Class Name for Structural Category must be unique.');
      return false;
    }
    var duplicateCabinIndex = _.chain(gridData).map(function (group) {
      return [group.foCabin.toUpperCase(), group.cabinIndex];
    }).flatten().uniq().value().length;
    if (duplicateCabinIndex % 2 !== 0) {
      toastr.error('Cabin and Cabin Index must be unique.');
      return false;
    }
    var classIndexArrayLength = _.chain(gridData).map(function (group) {
      return group.classIndex;
    }).flatten().uniq().value().length;
    if (classIndexArrayLength !== gridData.length) {
      toastr.error('Class Index must be unique.');
      return false;
    }
    return true;
  }
  function validateFORBDLevelFareThreshold(editedRows, gridData) {
    var isValid = true;
    if (containsDuplicateRBDFareThresholdProperty(gridData)) {
      isValid = false;
      toastr.error('Duplicate row added for fare type indicator, tariff and rbd.');
    }
    _.forEach(editedRows, function (editedRow) {
      if (_.includes(editedRow, 'minFareThreshold') && _.isNil(editedRow.minFareThreshold) && _.isNil(editedRow.minFareThresholdPercent) || _.isNil(editedRow.maxFareThreshold) && _.isNil(editedRow.maxFareThresholdPercent)) {
        toastr.error('Fare Thresholds are not added');
        isValid = false;
      }
    });
    return isValid;
  }
  function containsDuplicateRBDFareThresholdProperty(gridData) {
    var tripTypeTariffAndRbd = [];
    _.forEach(gridData, function (row) {
      _.forEach(row.fareTypeIndicator.split(','), function (tripType) {
        tripTypeTariffAndRbd.push(row.foRbd + tripType + row.fareTariffNumber);
      });
    });
    return new Set(tripTypeTariffAndRbd).size !== tripTypeTariffAndRbd.length;
  }
  function validateFareClassMapping(editedRows, gridData) {
    var isValid = true;
    _.forEach(editedRows, function (row) {
      if ((_.isEmpty(row.hostFareBrand) || _.isNil(row.hostFareBrand)) && !_.isNil(row.competitorFareBrand) && !_.isEmpty(row.competitorFareBrand)) {
        isValid = false;
        toastr.error('Host Fare Brand is missing');
      }
      if (isFareClassMappingCompetitorFareBrandInvalid(row, row.competitorAirline)) {
        isValid = false;
        toastr.error('Selected competitor fare brands are not applicable for ' + row.competitorAirline);
      }
      var regExp = 'WEB' === row.fareSource.toUpperCase() ? /^[A-Z](,[A-Z])*$|^-$/i : /^[A-Z](,[A-Z])*$/i;
      if (!regExp.test(row.competitorEntryLevelRbds)) {
        isValid = isValid && false;
        toastr.error('Competitor rbd value should be comma separated uppercase alplabets or can be - for web source');
      }
    });
    var fareClassMappingKeyValues = _.groupBy(gridData, function (row) {
      return advancedHepCommonValidationService.constructKey(row, AdvancedHepGridConstants.FO_FARE_CLASS_MAPPING_KEY_VALUES);
    });
    for (var key1 in fareClassMappingKeyValues) {
      var groupingByInventoryAssignment = _.groupBy(fareClassMappingKeyValues[key1], 'inventoryAssignmentMethod');
      if (!_.isEmpty(groupingByInventoryAssignment)) {
        var entries = groupingByInventoryAssignment['ORDINAL'];
        if (isValid && !_.isEmpty(entries) && containsMultipleRowsForOrdinal(entries)) {
          isValid = false;
          toastr.error('For ORDINAL matching, Host RBDs should be same for same fare type, host fare brand and competitor carrier. ');
        }
      }
    }
    for (var key in fareClassMappingKeyValues) {
      if (isValid && areFareClassMappingFieldsOverlapping(fareClassMappingKeyValues[key])) {
        isValid = false;
      }
    }
    if (isValid && sameFareTypeContainsDifferentBenchmarkingMethod(gridData, 'inventoryAssignmentMethod')) {
      isValid = false;
      toastr.error('Inventory Assignment Method should be same for same fare type indicator.');
    }
    if (isValid && sameFareTypeContainsDifferentBenchmarkingMethod(gridData, 'ladderGenerationMethod')) {
      isValid = false;
      toastr.error('Ladder Generation Method should be same for same fare type indicator.');
    }
    return isValid;
  }
  function areFareClassMappingFieldsOverlapping(entries) {
    var areFieldsOverlapping = false;
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          var from = _.split(advancedHepCommonValidationService.constructKey(entries[i], AdvancedHepGridConstants.FO_FARE_CLASS_MAPPING_OVERLAPPING_FIELD_VALUES), '.');
          var to = _.split(advancedHepCommonValidationService.constructKey(entries[j], AdvancedHepGridConstants.FO_FARE_CLASS_MAPPING_OVERLAPPING_FIELD_VALUES), '.');
          if (_.intersection(_.split(from[0], ','), _.split(to[0], ',')).length > 0 && entries[i].hostEntryLevelRBD === entries[j].hostEntryLevelRBD && entries[i].fareSource === entries[j].fareSource && _.intersection(_.split(from[1], ','), _.split(to[1], ',')).length > 0) {
            toastr.error('Duplicate row added for competitor fare source, fare type indicator, host RBD, competitor airline and host fare brand. ');
            areFieldsOverlapping = true;
          }
        }
      }
    }
    return areFieldsOverlapping;
  }
  function containsMultipleRowsForOrdinal(entries) {
    var areFieldsOverlappingForOrdinal = false;
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          var from = _.split(advancedHepCommonValidationService.constructKey(entries[i], AdvancedHepGridConstants.FO_FARE_CLASS_MAPPING_OVERLAPPING_FIELD_VALUES), '.');
          var to = _.split(advancedHepCommonValidationService.constructKey(entries[j], AdvancedHepGridConstants.FO_FARE_CLASS_MAPPING_OVERLAPPING_FIELD_VALUES), '.');
          if (_.intersection(_.split(from[0], ','), _.split(to[0], ',')).length > 0 && _.intersection(_.split(from[1], ','), _.split(to[1], ',')).length > 0) {
            areFieldsOverlappingForOrdinal = true;
          }
        }
      }
    }
    return areFieldsOverlappingForOrdinal;
  }
  function sameFareTypeContainsDifferentBenchmarkingMethod(gridData, field) {
    var invalid = false;
    var fareTypeAndFieldMap = new Map();
    _.forEach(gridData, function (row) {
      var fareTypeIndicator = row.fareTypeIndicator.split(',');
      _.forEach(fareTypeIndicator, function (fareType) {
        if (fareTypeAndFieldMap.has(fareType)) {
          if (fareTypeAndFieldMap.get(fareType) !== row[field]) {
            invalid = true;
          }
        } else {
          fareTypeAndFieldMap.set(fareType, row[field]);
        }
      });
    });
    return invalid;
  }
  function validateMarketConfigModals(editedRows, gridData) {
    var isValid = true;
    if (featureToggleService.isEnabled('DYNAMIC_PRICING') && !_.isEmpty(gridData) && _.has(gridData[0], 'losStart')) {
      if (gridData.length > MAX_LOS_RANGES) {
        return false;
      }
      var sortedByStart = _.sortBy(gridData, 'losStart');
      if (sortedByStart[0].losStart !== MIN_LOS_START || sortedByStart[sortedByStart.length - 1].losEnd !== MAX_LOS_END) {
        return false;
      }
      isValid = validateLOSRangesToBeConsequent(sortedByStart);
    }
    if (featureToggleService.isEnabled('DYNAMIC_AVAILABILITY_ML_MODEL') && !_.isEmpty(gridData) && _.has(gridData[0], 'cabinCodeForMl')) {
      var cabins = _.map(gridData, 'cabinCodeForMl');
      isValid = isValid && cabins.length === _.uniq(cabins).length;
    }
    return isValid;
  }
  function validateLOSRangesToBeConsequent(sortedByStart) {
    var i = 0;
    for (var k = 1; k < sortedByStart - 1, i < sortedByStart.length - 1; k++) {
      if (sortedByStart[i].losEnd !== sortedByStart[k].losStart - 1) {
        return false;
      }
      i++;
    }
    return true;
  }
  function validateFareBrandAssignment(editedRows, gridData) {
    var isValid = true;
    var grouping = _.groupBy(gridData, function (gridRow) {
      return _.isEmpty(gridRow.inclusionFbcPattern) ? '' : gridRow.inclusionFbcPattern.toUpperCase();
    });
    if (containsDuplicateField(grouping, 'inclusionFbcPattern')) {
      isValid = false;
      toastr.error('Duplicate row added for Inclusion FBC Pattern');
    }
    _.forEach(editedRows, function (row) {
      if (_.isEmpty(row.fareBrand) || _.isNil(row.fareBrand)) {
        isValid = false;
        toastr.error('Fare Brand Cannot be empty');
      }
      if (_.isEmpty(row.inclusionFbcPattern) && _.isEmpty(row.exclusionFbcPattern) && _.isEmpty(row.ruleNumber)) {
        isValid = false;
        toastr.error('At least one value from Inclusion FBC Pattern, Exclusion FBC Pattern and Rule Number is required');
      }
    });
    var groupByInclusionFbcPattern = _.groupBy(gridData, function (gridRow) {
      return _.isEmpty(gridRow.inclusionFbcPattern) ? '' : gridRow.inclusionFbcPattern.toUpperCase();
    });
    _.forEach(_.keys(groupByInclusionFbcPattern), function (inclusionFbcPattern) {
      var groupByInclusionFbcPatternElement = groupByInclusionFbcPattern[inclusionFbcPattern];
      if (groupByInclusionFbcPatternElement.length > 1) {
        var groupByExclusionFbcPattern = _.groupBy(groupByInclusionFbcPatternElement, function (value) {
          return _.isEmpty(value.exclusionFbcPattern) ? '' : value.exclusionFbcPattern.toUpperCase();
        });
        _.forEach(_.keys(groupByExclusionFbcPattern), function (exclusionFbcPattern) {
          var groupByExclusionFbcPatternElement = groupByExclusionFbcPattern[exclusionFbcPattern];
          if (groupByInclusionFbcPatternElement.length > 1) {
            var groupByRuleNumber = _.groupBy(groupByExclusionFbcPatternElement, function (value) {
              return _.isEmpty(value.ruleNumber) ? '' : value.ruleNumber;
            });
            _.forEach(_.keys(groupByRuleNumber), function (ruleNumber) {
              var groupByRuleNumberElement = groupByRuleNumber[ruleNumber];
              if (groupByRuleNumberElement.length > 1) {
                isValid = false;
                toastr.error('Duplicate row identified with Inclusion FBC Pattern, Exclusion FBC Pattern or Rule Number');
              }
            });
          }
        });
      }
    });
    return isValid;
  }
  function validateFORuleMappingDOW(editedRows, gridData) {
    var isValid = true;
    var oneToSevenCommaSeparatedRegex = new RegExp('^[1-7,\|]*$');
    var oneToSevenWithPipeRegex = new RegExp('^[1-7]*\\|?[1-7]*$');
    _.forEach(editedRows, function (row) {
      if (!oneToSevenCommaSeparatedRegex.test(row.filedDow)) {
        isValid = false;
        toastr.error('Filed Dow must contain the 1-7 values comma separated values');
      } else {
        var fileDowSections = row.filedDow.split(',');
        var _iterator = _createForOfIteratorHelper(fileDowSections),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var fileDowSection = _step.value;
            if (!oneToSevenWithPipeRegex.test(fileDowSection)) {
              isValid = false;
              toastr.error('Filed Dow sections should contain one or zero Pipe Char(|) only');
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (!_.isEmpty(row.filedAmount) && !isValidFiledAmount(row.filedAmount)) {
        isValid = false;
        toastr.error('Filed Amount must contain a positive numeric value or a numeric valid range');
      }
      if (!oneToSevenWithPipeRegex.test(row.mappedDow)) {
        isValid = false;
        toastr.error('Mapped Dow must contain the 1-7 numeric values or single | ');
      }
      if (isValid && areFORuleMappingDOWPropertiesOverlapping(gridData)) {
        isValid = false;
      }
    });
    return isValid;
  }
  function areFORuleMappingDOWPropertiesOverlapping(entries) {
    var areFieldsOverlapping = false;
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          if (areCommaSeparatedValuesOverlapping(entries[i].fareSource, entries[j].fareSource) && entries[i].fareTariffNumber === entries[j].fareTariffNumber && entries[i].filedDow === entries[j].filedDow && _.trim(entries[i].filedAmount) === _.trim(entries[j].filedAmount) && areCommaSeparatedValuesOverlapping(entries[i].fareTypeIndicator, entries[j].fareTypeIndicator)) {
            toastr.error('Duplicate row added for fare source, tariff, fare type indicator, filedDow, filedAmount. ');
            areFieldsOverlapping = true;
          }
        }
      }
    }
    return areFieldsOverlapping;
  }
  function validateTacticalFareDefinition(editedRows, gridData) {
    var isValid = true;
    /*var grouping = _.groupBy(gridData, function (gridRow) {
        return gridRow.inclusionFbcPattern.toUpperCase();
    });
    if (containsDuplicateField(grouping, 'inclusionFbcPattern')) {
        isValid = false;
        toastr.error('Duplicate row added for Inclusion FBC Pattern');
    }*/

    _.forEach(editedRows, function (row) {
      if (_.isEmpty(row.fareSource) || _.isNil(row.fareSource)) {
        isValid = false;
        toastr.error('Fare Source cannot be empty');
      }
      if (_.isEmpty(row.grouping) || _.isNil(row.grouping)) {
        isValid = false;
        toastr.error('Grouping cannot be empty');
      }
      if (_.isEmpty(row.criteriaType) || _.isNil(row.criteriaType)) {
        isValid = false;
        toastr.error('Criteria Type cannot be empty');
      }
      if (_.isEmpty(row.criteria) || _.isNil(row.criteria)) {
        isValid = false;
        toastr.error('Criteria cannot be empty');
      }
      if (_.isEmpty(row.operator) || _.isNil(row.operator)) {
        isValid = false;
        toastr.error('Operator cannot be empty');
      }
      if (_.isEmpty(row.value) || _.isNil(row.value)) {
        isValid = false;
        toastr.error('Value cannot be empty');
      }
      if ((_.isEmpty(row.compMatch) || _.isNil(row.compMatch)) && 'SECONDARY' === row.grouping.toUpperCase()) {
        isValid = false;
        toastr.error('Comp Match cannot be empty');
      }
      if ((!_.isEmpty(row.compMatch) || !_.isNil(row.compMatch)) && 'PRIMARY' === row.grouping.toUpperCase()) {
        //row.compMatch = null;
        //isValid = false;
        //toastr.error('Comp Match should be empty for Primary Grouping');
      }
      if (!_.isEmpty(row.grouping) && !_.isNil(row.grouping) && 'PRIMARY' === row.grouping.toUpperCase()) {
        if ('WEB' === row.fareSource.toUpperCase() && 'AMOUNT' !== row.criteriaType.toUpperCase() && 'DATE' !== row.criteriaType.toUpperCase() && 'RBD' !== row.criteriaType.toUpperCase()) {
          isValid = isValid && false;
          toastr.error('Criteria Type should be Amount or Date or RBD when fare Source is WEB and grouping is set to Primary');
        }
        if ('WEB' === row.fareSource.toUpperCase() && 'RBD' !== row.criteriaType.toUpperCase() && _.trim(row.operator) !== '<' && _.trim(row.operator) !== '=') {
          isValid = isValid && false;
          toastr.error('Operator should be < or = when fare source is WEB and grouping is set to Primary and Criteria Type is not RBD');
        }
      }
      if (!_.isEmpty(row.grouping) && !_.isNil(row.grouping) && 'SECONDARY' === row.grouping.toUpperCase()) {
        if ('WEB' === row.fareSource.toUpperCase() && 'DATE' !== row.criteriaType.toUpperCase()) {
          isValid = isValid && false;
          toastr.error('Criteria Type should be DATE when fare source is WEB and grouping is set to Secondary');
        } else if ('DATE' !== row.criteriaType.toUpperCase() && 'AP' !== row.criteriaType.toUpperCase()) {
          isValid = isValid && false;
          toastr.error('Criteria Type should be DATE or AP when fare source is ATPCO and grouping is set to Secondary');
        }
      }
      if ('AMOUNT' === row.criteriaType.toUpperCase()) {
        if ('WEB' !== row.fareSource.toUpperCase() || 'PRIMARY' !== row.grouping.toUpperCase()) {
          isValid = isValid && false;
          toastr.error('Fare source should be WEB and grouping should be set to Primary when Criteria Type is Amount');
        }
        if ('WEB' === row.fareSource.toUpperCase() && 'PRIMARY' === row.grouping.toUpperCase() && 'TOTAL FARE' !== row.criteria.toUpperCase() && 'BASE FARE' !== row.criteria.toUpperCase()) {
          isValid = isValid && false;
          toastr.error('Criteria should be Total Fare or Base Fare when fare source is WEB, grouping is set to Primary and Criteria Type is Amount');
        }
      }
      if ('DATE' === row.criteriaType.toUpperCase()) {
        if ('WEB' === row.fareSource.toUpperCase() && 'PRIMARY' === row.grouping.toUpperCase() && 'DEPARTURE DATE' !== row.criteria.toUpperCase()) {
          isValid = isValid && false;
          toastr.error('Criteria should be Departure Date when fare source is WEB and grouping is set to Primary and Criteria Type is Date');
        } else if (!_.split(_.trim(row.criteria), 'End Date').length > 1) {
          isValid = isValid && false;
          toastr.error('Criteria should be End Date when criteria Type is Date');
        }
      }
      if ('RBD' === row.criteriaType.toUpperCase()) {
        if (_.trim(row.criteria) !== 'RBD') {
          isValid = isValid && false;
          toastr.error('Criteria should be RBD when Criteria Type is set to RBD');
        }
        if (_.trim(row.operator) !== '=' && _.trim(row.operator) !== '!=') {
          isValid = isValid && false;
          toastr.error('Operator should be = or != when Criteria Type is set to RBD');
        }
      }
      if ('AP' === row.criteriaType.toUpperCase()) {
        if (_.trim(row.criteria) !== 'AP-Res' && _.trim(row.criteria) !== 'AP-Tkt') {
          isValid = isValid && false;
          toastr.error('Criteria should be AP-Res or AP-Tkt when Criteria Type is set to AP');
        }
      }
      if ('MMS' === row.criteriaType.toUpperCase()) {
        if (_.trim(row.criteria) !== 'Min Stay' && _.trim(row.criteria) !== 'Max Stay') {
          isValid = isValid && false;
          toastr.error('Criteria should be Min Stay or Max Stay when Criteria Type is set to MMS');
        }
      }
      var regExp = 'RBD' === row.criteriaType.toUpperCase() ? 'WEB' === row.fareSource.toUpperCase() ? /^[A-Z](,[A-Z])*$|^-$/i : /^[A-Z](,[A-Z])*$/i : /^[\d]+$/i;
      if (!regExp.test(row.value)) {
        isValid = isValid && false;
        toastr.error('Value should be comma separated uppercase alplabet or can be - for web source for RBD and digits for other types');
      }
      if ('TOTAL FARE' === row.criteria.toUpperCase() || 'BASE FARE' === row.criteria.toUpperCase()) {
        if ('WEB' !== row.fareSource.toUpperCase() || 'PRIMARY' !== row.grouping.toUpperCase() || 'AMOUNT' !== row.criteriaType.toUpperCase()) {
          isValid = isValid && false;
          toastr.error('Fare source should be WEB, grouping should be set to Primary and Criteria Type should be Amount when Criteria is Total Fare/Base Fare');
        }
      }
      if ('DEPARTURE DATE' === row.criteria.toUpperCase()) {
        if ('WEB' !== row.fareSource.toUpperCase() || 'PRIMARY' !== row.grouping.toUpperCase() || 'DATE' !== row.criteriaType.toUpperCase()) {
          isValid = isValid && false;
          toastr.error('Fare source should be WEB, grouping should be set to Primary and Criteria Type should be DATE when Criteria is Departure Date');
        }
      }
      if (areTacticalFareDefinitionsDuplicate(gridData)) {
        isValid = false;
      }
    });
    return isValid;
  }
  function areTacticalFareDefinitionsDuplicate(entries) {
    var areFieldsOverlapping = false;
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          var from = entries[i];
          var to = entries[j];
          if (areCommaSeparatedValuesOverlapping(from.value, to.value) && from['fareSource'] === to['fareSource'] && from.competitorTariff === to.competitorTariff && from['grouping'] === to['grouping'] && from['criteriaType'] === to['criteriaType'] && from['criteria'] === to['criteria'] && from['compMatch'] === to['compMatch'] && from['operator'] === to['operator']) {
            toastr.error('Duplicate rows identified');
            areFieldsOverlapping = true;
          }
        }
      }
    }
    return areFieldsOverlapping;
  }
  function isFareClassMappingCompetitorFareBrandInvalid(row, airline) {
    return !_.isNil(row.competitorFareBrand) && !_.isEmpty(row.competitorFareBrand) && _.intersection(getCompetitorFareBrands(airline), _.split(row.competitorFareBrand, ',')).length !== _.split(row.competitorFareBrand, ',').length;
  }
  function validateFORuleMappingMaxStay(editedRows, gridData) {
    var isValid = true;
    _.forEach(editedRows, function (row) {
      if (!isPositiveIntegerNumber(row.filedStart) || !isPositiveIntegerNumber(row.filedEnd) || _.toNumber(row.filedStart) > _.toNumber(row.filedEnd)) {
        isValid = false;
        toastr.error('Filed Start and Filed End should be valid positive values and also Filed End Must be greater than Filed Start');
      }
      if (!_.isEmpty(row.filedAmount) && !isValidFiledAmount(row.filedAmount)) {
        isValid = false;
        toastr.error('Filed Amount must contain a positive numeric value or a numeric valid range');
      }
      if (!isPositiveIntegerNumber(row.mappedMaxStay)) {
        isValid = false;
        toastr.error('Mapped Max Stay must contain a numeric value');
      }
    });
    if (isValid && areFORuleMappingMinMaxStayPropertiesOverlapping(gridData)) {
      isValid = false;
    }
    return isValid;
  }
  function isValidFiledAmount(filedAmount) {
    if (filedAmount === null || filedAmount === undefined || filedAmount === '') {
      return true;
    }
    if (filedAmount.includes('-') && filedAmount.indexOf('-') !== 0) {
      var numbers = filedAmount.split('-');
      if (numbers.length !== 2) {
        return false;
      }
      var n1 = _.toNumber(numbers[0]);
      var n2 = _.toNumber(numbers[1]);
      return isPositiveNumber(numbers[0]) && isPositiveNumber(numbers[1]) && n1 < n2;
    }
    return isPositiveNumber(filedAmount);
  }
  function areFORuleMappingMinMaxStayPropertiesOverlapping(entries) {
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          if (areCommaSeparatedValuesOverlapping(entries[i].fareSource, entries[j].fareSource) && areCommaSeparatedValuesOverlapping(entries[i].fareTypeIndicator, entries[j].fareTypeIndicator) && isFORuleMappingMinMaxStayFiledStartEndOverlapping(entries[i], entries[j]) && isFORuleMappingFiledAmountOverlapping(entries[i], entries[j]) && entries[i].fareTariffNumber === entries[j].fareTariffNumber) {
            toastr.error('Duplicate row added for fare source, tariff, fare type indicator, filedStart, filedEnd, filedAmount. ');
            return true;
          }
        }
      }
    }
    return false;
  }
  function isFORuleMappingMinMaxStayFiledStartEndOverlapping(first, second) {
    return isRangeOverLapping(first.filedStart, first.filedEnd, second.filedStart, second.filedEnd);
  }
  function isFORuleMappingFiledAmountOverlapping(first, second) {
    if (first.filedAmount === second.filedAmount) {
      return true;
    }
    if (_.isEmpty(first.filedAmount) || _.isEmpty(first.filedAmount)) {
      return false;
    }
    var firstStart;
    var firstEnd;
    var secondStart;
    var secondEnd;
    if (first.filedAmount.includes('-')) {
      var ranges = first.filedAmount.split('-');
      firstStart = ranges[0];
      firstEnd = ranges[1];
    } else {
      firstStart = first.filedAmount;
      firstEnd = first.filedAmount;
    }
    if (second.filedAmount.includes('-')) {
      var _ranges = second.filedAmount.split('-');
      secondStart = _ranges[0];
      secondEnd = _ranges[1];
    } else {
      secondStart = second.filedAmount;
      secondEnd = second.filedAmount;
    }
    return isRangeOverLapping(firstStart, firstEnd, secondStart, secondEnd);
  }
  function isRangeOverLapping(firstStart, firstEnd, secondStart, secondEnd) {
    return firstStart === secondStart || firstEnd === secondEnd || _.toNumber(firstStart) <= _.toNumber(secondEnd) && _.toNumber(secondStart) <= _.toNumber(firstEnd);
  }
  function isPositiveIntegerNumber(value) {
    var toNumber = _.toNumber(value);
    return !_.isNaN(toNumber) && toNumber >= 0 && !value.includes('.');
  }
  function isPositiveNumber(value) {
    var toNumber = _.toNumber(value);
    return !_.isNaN(toNumber) && toNumber >= 0;
  }
  function validateFORuleMappingMinStay(editedRows, gridData) {
    var isValid = true;
    _.forEach(editedRows, function (row) {
      if (!isPositiveIntegerNumber(row.filedStart) || !isPositiveIntegerNumber(row.filedEnd) || _.toNumber(row.filedStart) > _.toNumber(row.filedEnd)) {
        isValid = false;
        toastr.error('Filed Start and Filed End should be valid positive values and also Filed End Must be greater than Filed Start');
      }
      if (!_.isEmpty(row.filedAmount) && !isValidFiledAmount(row.filedAmount)) {
        isValid = false;
        toastr.error('Filed Amount must contain a positive numeric value or a numeric valid range');
      }
      if (!isPositiveIntegerNumber(row.mappedMinStay)) {
        isValid = false;
        toastr.error('Mapped Min Stay must contain a numeric value');
      }
    });
    if (isValid && areFORuleMappingMinMaxStayPropertiesOverlapping(gridData)) {
      isValid = false;
    }
    return isValid;
  }
  function containsDuplicateField(grouping, field) {
    return _.find(_.values(grouping), function (array) {
      if (array.length > 1) {
        var fareBrandAssignments = _.chain(array).filter(function (o) {
          return !_.isEmpty(o[field]);
        }).map(function (o) {
          return o[field].toUpperCase();
        }).flatten().value();
        return new Set(fareBrandAssignments).size !== fareBrandAssignments.length;
      }
      return false;
    });
  }
  function validateAnalystPosMapping(editedRows, allRows) {
    var isValid = true;
    var columnsToCheck = ['level'];
    _.forEach(editedRows, function (row) {
      if (advancedHepCommonValidationService.isDuplicate(row, allRows, columnsToCheck)) {
        toastr.error('Level should be unique.');
        isValid = false;
      }
    });
    return isValid;
  }
  function validateSeasonLevelMatchThreshold(editedRows, allRows) {
    var isValid = true;
    for (var i = 0; i < allRows.length; i++) {
      for (var j = i + 1; j < allRows.length; j++) {
        if (hasDuplicateEntryForTripTypeAndSource(allRows[i], allRows[j], 'fareTypeIndicator', 'fareSource')) {
          isValid = false;
        }
      }
    }
    if (!isValid) {
      toastr.error('Duplicate row added for fare type indicator and fare Source');
    }
    return isValid;
  }
  function isPropertiesOverlapped(editedRows, gridData, type, rangesProperties) {
    var result = false;
    if (editedRows !== undefined && editedRows.length > 0) {
      var ranges = _.isUndefined(rangesProperties) ? advancedHepCommonValidationService.getRangeTypes(type) : rangesProperties;
      if (type === 'FOAdvancePurchaseGrouping') {
        if (advancedHepCommonValidationService.isRangesAreOverlappingForAP(gridData, ranges)) {
          result = true;
        }
      } else {
        if (advancedHepCommonValidationService.isRangesAreOverlapping(gridData, ranges)) {
          result = true;
        }
      }
    }
    if (result) {
      toastr.error('Overlapping rows identified.');
    }
    return result;
  }
  function validateInputDataComparisonChecks(editedRows, gridData) {
    var isValid = true;
    var columnsToCheck = ['inputType', 'fareTariffNumber', 'inputSource'];
    _.forEach(editedRows, function (row) {
      if (advancedHepCommonValidationService.isDuplicate(row, gridData, columnsToCheck)) {
        isValid = false;
        toastr.error('Duplicate row added for Input Source, Tariff and Input Type');
      }
    });
    _.forEach(editedRows, function (row) {
      if (_.isNil(row.absoluteChange) && _.isNil(row.percentageChange)) {
        isValid = false;
        toastr.error('Atleast one of Absolute/Percentage change must be defined for Input Source and Type.');
      }
    });
    _.forEach(editedRows, function (row) {
      if (isInvalidInputTypeForInputSource(row.inputSource, row.inputType)) {
        isValid = false;
        toastr.error(' Incorrect Input Type ' + row.inputType + ' for Input Source ' + row.inputSource);
      }
    });
    return isValid;
  }
  function isInvalidInputTypeForInputSource(inputSource, inputType) {
    return !INPUT_SOURCE_TYPES[inputSource].includes(inputType);
  }
  function validateRoutingNumberAndViaPoints(editedRows, allRows) {
    var areViaPointsValid = validateConnectionField(editedRows, allRows);
    var isValid = true;
    var columnsToCheck = ['routingNumber', 'fareTariffNumber'];
    _.forEach(editedRows, function (row) {
      if (advancedHepCommonValidationService.isDuplicate(row, allRows, columnsToCheck)) {
        toastr.error('Duplicate row added for same routing number');
        isValid = false;
      }
    });
    return isValid && areViaPointsValid;
  }
  function validateConnectionField(editedRows, allRows) {
    var isValid = true;
    for (var i = 0; i < allRows.length; i++) {
      for (var j = i + 1; j < allRows.length; j++) {
        if (hasDuplicateEntryForViaPoints(allRows[i], allRows[j], 'connectionInbound', 'connectionOutbound')) {
          isValid = false;
        }
      }
    }
    if (!isValid) {
      toastr.error('Duplicate row added for total fare hub definition');
    }
    return isValid;
  }
  function hasDuplicateEntryForViaPoints(newEntry, entry, field1, field2) {
    var newEntryValues = _.split(newEntry[field1], ',');
    var existingEntryValues = _.split(entry[field1], ',');
    var newEntryValues1 = _.split(newEntry[field2], ',');
    var existingEntryValues1 = _.split(entry[field2], ',');
    return isOverlappingConnectionField(newEntryValues, existingEntryValues) && isOverlappingConnectionField(newEntryValues1, existingEntryValues1);
  }
  function isOverlappingConnectionField(newEntryValues, existingEntryValues) {
    return newEntryValues.length == existingEntryValues.length && newEntryValues.sort().every(function (element, index) {
      return element === existingEntryValues.sort()[index];
    });
  }
  function validateFareBrandAssignmentModal(editedRows, gridData) {
    var configs = _.map(gridData, function (row) {
      return row.fareBrandConfiguration + row.inclusionFbcPattern + row.exclusionFbcPattern;
    });
    return configs.length === _.uniq(configs).length;
  }
  function validateTacticalFBCPatternConfig(editedRows, allRows) {
    var isValid = true;
    var columnsToCheck = ['fareSource', 'position', 'include', 'exclude'];
    _.forEach(editedRows, function (row) {
      if (advancedHepCommonValidationService.isDuplicate(row, allRows, columnsToCheck)) {
        isValid = false;
        toastr.error('Duplicate row added');
      }
    });
    return isValid;
  }
  function validateApplicableDateMapping(editedRows, gridData) {
    var isValid = true;
    _.forEach(editedRows, function (row) {
      var errorMessage = '';
      if (_.isEmpty(row.fareSource) || _.isNil(row.fareSource)) {
        isValid = false;
        errorMessage = 'Fare Source cannot be empty';
      } else if (_.isEmpty(row.fareTypeIndicator) || _.isNil(row.fareTypeIndicator)) {
        isValid = false;
        errorMessage = 'Fare Type cannot be empty';
      } else if (!_.isEmpty(row.filedAmount) && !isValidFiledAmount(row.filedAmount)) {
        isValid = false;
        errorMessage = 'Filed Amount must contain a positive numeric value or a numeric valid range';
      } else if (_.isEmpty(row.mappedApplDates) && _.isNil(row.mappedApplDates)) {
        isValid = false;
        errorMessage = 'Mapped Appl Dates cannot be empty';
      } else {
        var allowedApplDates = configurationParametersAdvancedService.extractSeasonDetails().seasonsAbbreviation.concat('-');
        if (!allowedApplDates.includes(row.mappedApplDates)) {
          isValid = false;
          errorMessage = 'Mapped Appl Dates should contain ' + allowedApplDates;
        }
      }
      if (!isValid) {
        toastr.error(errorMessage);
      }
      isValid = isValid && validateApplicationDateMappingPropertiesWhenSplitOnStrucFalse(row) && validateApplicationDateMappingPropertiesWhenSplitOnStrucTrue(row) && validateApplicationDateMappingPropertiesForFbcPattern(row);
    });
    if (areApplicableDateMappingPropertiesDuplicate(gridData)) {
      isValid = false;
      toastr.error('Duplicate row added for fare source, tariff, fare type indicator and fbc pattern. ');
    }
    return isValid;
  }
  function validateApplicationDateMappingPropertiesWhenSplitOnStrucFalse(row) {
    var isValid = true;
    if ((_.isNil(row.splitOnStruc) || _.isEmpty(row.splitOnStruc) || row.splitOnStruc === false) && (_.isNil(row.datesThreshold) || _.isEmpty(row.datesThreshold)) && (_.isNil(row.dates) || _.isEmpty(row.dates)) && (_.isNil(row.fbcPattern) || _.isEmpty(row.fbcPattern)) && (_.isNil(row.filedAmount) || _.isEmpty(row.filedAmount)) && (_.isNil(row.mappedApplDates) || _.isEmpty(row.mappedApplDates))) {
      isValid = false;
      toastr.error('None of Dates, Dates Threshold, Split on Struc, Fbc Pattern, Filed Amount and Mapped Appl Dates is filled');
    }
    return isValid;
  }
  function validateApplicationDateMappingPropertiesWhenSplitOnStrucTrue(row) {
    var isValid = true;
    if (row.splitOnStruc === true) {
      if (row.datesThreshold !== null && row.datesThreshold !== '' && row.datesThreshold % 1 === 0 || !_.isEmpty(row.dates) && !_.isNil(row.dates) || !_.isEmpty(row.filedAmount) && !_.isNil(row.filedAmount) || !_.isEmpty(row.fbcPattern) && !_.isNil(row.fbcPattern)) {
        isValid = false;
        toastr.error('Dates, Dates Threshold, Filed Amount and Fbc Pattern should not be filled up if split on struc is checked');
      }
    }
    return isValid;
  }
  function validateApplicationDateMappingPropertiesForFbcPattern(row) {
    var isValid = true;
    if ((checkNotBlankDateThreshold(row) || checkNotBlankDate(row)) && !_.isNil(row.fbcPattern) && !_.isEmpty(row.fbcPattern)) {
      isValid = false;
      toastr.error('Fbc Pattern should not be filled up if dates threshold or dates is populated');
    }
    return isValid;
  }
  function checkNotBlankDateThreshold(row) {
    return !_.isNil(row.datesThreshold) && row.datesThreshold !== '';
  }
  function checkNotBlankDate(row) {
    return !_.isNil(row.dates) && !_.isEmpty(row.dates);
  }
  function areApplicableDateMappingPropertiesDuplicate(entries) {
    var areFieldsOverlapping = false;
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          var from = entries[i];
          var to = entries[j];
          if (checkApplicableDateMappingPropertiesDuplicate(from, to)) {
            areFieldsOverlapping = true;
          }
        }
      }
    }
    return areFieldsOverlapping;
  }
  function checkApplicableDateMappingPropertiesDuplicate(from, to) {
    return areApplicableDateMappingPropertiesOverlappingDuplicate(from, to) && areDateThresholdAndDatesDuplicate(from, to) && isSplitOnStrucDuplicate(from, to) && areFiledAmountAndMappedApplDatesDuplicate(from, to);
  }
  function areApplicableDateMappingPropertiesOverlappingDuplicate(from, to) {
    return areCommaSeparatedValuesOverlapping(from.fareSource, to.fareSource) && areCommaSeparatedValuesOverlapping(from.fareTypeIndicator, to.fareTypeIndicator) && areCommaSeparatedValuesOverlapping(from.fbcPattern, to.fbcPattern) && from.fareTariffNumber === to.fareTariffNumber;
  }
  function areDateThresholdAndDatesDuplicate(from, to) {
    return from['datesThreshold'] === to['datesThreshold'] && from['dates'] === to['dates'];
  }
  function isSplitOnStrucDuplicate(from, to) {
    return from['splitOnStruc'] === to['splitOnStruc'];
  }
  function areFiledAmountAndMappedApplDatesDuplicate(from, to) {
    return from['filedAmount'] === to['filedAmount'] && from['mappedApplDates'] === to['mappedApplDates'];
  }
  function validateFareBasisCodePattern(editedRows, gridData) {
    var isValid = true;
    _.forEach(gridData, function (row) {
      if (_.isEmpty(row.property) || _.isNil(row.property)) {
        isValid = false;
        toastr.error('Property cannot be empty');
      }
      if (_.isEmpty(row.fileRules) || _.isNil(row.fileRules)) {
        isValid = false;
        toastr.error('File Rules cannot be empty');
      }
      isValid = isValid && validateFareBasisCodePatternPropertyValues(row);
    });
    if (areFareBasisCodePatternPropertiesDuplicate(gridData)) {
      isValid = false;
      toastr.error('Duplicate row added');
    }
    if (areSameFareBasisCodePropertyHaveDifferentFileRule(gridData)) {
      isValid = false;
      toastr.error('Same Property cannot have different File Rules');
    }
    return isValid;
  }
  function validateFareBasisCodePatternPropertyValues(row) {
    var isValid;
    if (!checkPropertyNull(row.property.toUpperCase(), row.propertyValue)) {
      return false;
    }
    if (checkPropertyValueOther(row.property.toUpperCase(), row.propertyValue)) {
      return true;
    }
    switch (row.property.toUpperCase()) {
      case 'POC':
        {
          var allowedPocValues = _.chain(configurationService.getFoAirportRegionMapping(), row).map(function (e) {
            return e.pos;
          }).uniq().sortBy().value();
          isValid = validateWithAllowedValues(allowedPocValues, row.propertyValue, 'POC');
          break;
        }
      case 'CONSTANT':
        {
          var constRegex = new RegExp('^[A-Za-z0-9\,]{1,100}$');
          isValid = _.isEmpty(row.propertyValue) || validateByRegex(row.propertyValue, constRegex, 'constant', 'alphanumeric');
          break;
        }
      case 'FBC PATTERN':
        {
          var fbcPatternRegex = new RegExp('^[A-Z0-9*%?#]{0,8}$');
          isValid = validateByRegex(row.propertyValue, fbcPatternRegex, 'Fbc pattern', 'uppercase alphanumeric or special characters "?", "*", "#", "%"');
          break;
        }
      case 'FARE BRAND':
        {
          var airlines = configurationService.getHostCarrier().split(',');
          var allowedFareBrand = _.transform(configurationService.getFoFareBrandDefinitions(), function (result, current) {
            if (_.includes(_.uniq(airlines), current.carrier)) {
              _.forEach(_.chain(current.fareBrands).map('fareBrand').value(), function (fareBrand) {
                result.push(fareBrand);
              });
            }
          });
          isValid = validateWithAllowedValues(allowedFareBrand, row.propertyValue, 'Fare Brand');
          break;
        }
      case 'FARE TYPE':
        {
          var allowedFareType = ['OW', 'RT', 'OWNC'];
          isValid = validateWithAllowedValues(allowedFareType, row.propertyValue, 'Fare Type');
          break;
        }
      case 'OB/IB':
        {
          var allowedBoundValues = ['OB', 'IB'];
          isValid = validateWithAllowedValues(allowedBoundValues, row.propertyValue, 'OB/IB');
          break;
        }
      case 'AMOUNT - BASE':
        {
          isValid = validateAmount(row.propertyValue, 'Base Amount');
          break;
        }
      case 'AMOUNT - TOTAL':
        {
          isValid = validateAmount(row.propertyValue, 'Total Amount');
          break;
        }
      case 'COMP CARRIER':
        {
          var hostCarriers = configurationService.getHostCarrier().split(',');
          var allowedCompCarriers = _.uniq(_.concat(hostCarriers, configurationService.getConfiguredHostCarriers().split(','), _.flatten(_.map(configurationService.getFoBenchmarkCarriers(), 'benchmarkCarriers'))));
          isValid = validateWithAllowedValues(allowedCompCarriers, row.propertyValue, 'Comp carrier');
          break;
        }
      case 'APPLICABLE DATES':
        {
          var allowedApplDates = configurationParametersAdvancedService.extractSeasonDetails().seasonsAbbreviation.concat(['OTHER', '-']);
          isValid = validateWithAllowedValues(allowedApplDates, row.propertyValue, 'Applicable Dates');
          break;
        }
      case 'DOW':
        {
          isValid = validateDoW(row.propertyValue);
          break;
        }
      case 'AP':
        {
          isValid = validateAPMinMaxStay(row.propertyValue, 'AP');
          break;
        }
      case 'MIN STAY':
        {
          isValid = validateAPMinMaxStay(row.propertyValue, 'Min Stay');
          break;
        }
      case 'MAX STAY':
        {
          isValid = validateAPMinMaxStay(row.propertyValue, 'Max Stay');
          break;
        }
      case 'HOST RBD':
        {
          var hostRbdRegex = new RegExp('^[A-Z]$');
          isValid = validateByRegex(row.propertyValue, hostRbdRegex, 'Host RBD', 'single or comma separated uppercase alphabetic');
          break;
        }
      default:
        {
          toastr.error(' contains invalid property');
          isValid = false;
        }
    }
    return isValid;
  }
  function checkPropertyNull(property, propertyValue) {
    if (property !== 'CONSTANT' && (_.isNil(propertyValue) || _.isEmpty(propertyValue))) {
      toastr.error('Property Value other than for Constant property cannot be null');
      return false;
    }
    return true;
  }
  function checkPropertyValueOther(propertyName, propertyValue) {
    if (propertyName === 'APPLICABLE DATES' && propertyValue === '-') {
      return true;
    }
    if (!propertyName.includes('STAY') && propertyValue === 'OTHER') {
      return true;
    }
    return false;
  }
  function validateWithAllowedValues(allowedValues, propertyValue, name) {
    if (_.intersection(_.split(allowedValues, ','), _.split(propertyValue, ',')).length !== _.split(propertyValue, ',').length) {
      toastr.error(name + ' property should contain ' + allowedValues);
      return false;
    }
    return true;
  }
  function validateByRegex(value, regex, name, allowedValues) {
    var arr = value.split(',');
    var _iterator2 = _createForOfIteratorHelper(arr),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var eachVal = _step2.value;
        if (!regex.test(eachVal)) {
          toastr.error(name + ' property should contain ' + allowedValues);
          return false;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return true;
  }
  function validateAmount(value, name) {
    if (!isValidFiledAmount(value)) {
      toastr.error(name + ' property must be numeric or double valued single or range');
      return false;
    }
    return true;
  }
  function validateDoW(value) {
    var doWArr = value.split(',');
    var oneToSevenWithPipeRegex = new RegExp('^[1-7]*\\|?[1-7]*$');
    var _iterator3 = _createForOfIteratorHelper(doWArr),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var doW = _step3.value;
        if (!oneToSevenWithPipeRegex.test(doW)) {
          toastr.error('DOW property should contain single or comma seperated 1-7 values optionally separated by pipe');
          return false;
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    return true;
  }
  function validateAPMinMaxStay(value, name) {
    var positiveNumRegex = '^(0|[1-9]\\d*)$';
    if (!value.match(positiveNumRegex)) {
      toastr.error(name + ' property should contain positive numeric value');
      return false;
    }
    return true;
  }
  function areFareBasisCodePatternPropertiesDuplicate(entries) {
    var areFieldsOverlapping = false;
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          var from = entries[i];
          var to = entries[j];
          if (checkFareBasisCodePatternPropertiesDuplicate(from, to)) {
            areFieldsOverlapping = true;
          }
        }
      }
    }
    return areFieldsOverlapping;
  }
  function areSameFareBasisCodePropertyHaveDifferentFileRule(entries) {
    var invalid = false;
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          var from = entries[i];
          var to = entries[j];
          if (from['property'] === to['property'] && from['fileRules'] !== to['fileRules']) {
            invalid = true;
          }
        }
      }
    }
    return invalid;
  }
  function checkFareBasisCodePatternPropertiesDuplicate(from, to) {
    return arePropertyAndFileRulesDuplicate(from, to) && arePropertyValueOverlappingDuplicate(from, to);
  }
  function arePropertyValueOverlappingDuplicate(from, to) {
    return _.intersection(_.split(from['propertyValue'], ','), _.split(to['propertyValue'], ',')).length > 0;
  }
  function arePropertyAndFileRulesDuplicate(from, to) {
    return from['property'] === to['property'] && from['fileRules'] === to['fileRules'];
  }
  function validateFORuleMappingAP(editedRows, gridData) {
    var isValid = true;
    _.forEach(editedRows, function (row) {
      if (!isPositiveIntegerNumber(row.filedStart) || !isPositiveIntegerNumber(row.filedEnd) || _.toNumber(row.filedStart) > _.toNumber(row.filedEnd)) {
        isValid = false;
        toastr.error('Filed Start and Filed End should be valid positive values and also Filed End Must be greater than Filed Start');
      }
      if (!_.isEmpty(row.filedAmount) && !isValidFiledAmount(row.filedAmount)) {
        isValid = false;
        toastr.error('Filed Amount must contain a positive numeric value or a numeric valid range');
      }
      if (!isPositiveIntegerNumber(row.mappedAP)) {
        isValid = false;
        toastr.error('Mapped AP must contain a numeric value');
      }
    });
    if (isValid && areFORuleMappingAPPropertiesOverlapping(gridData)) {
      isValid = false;
    }
    return isValid;
  }
  function validateFORuleMappingFareTariff(editedRows, gridData) {
    var isValid = true;
    _.forEach(editedRows, function (row) {
      if (hasInvalidCompetitorAirline(row)) {
        isValid = false;
        toastr.error('Competitor airline must have 2 characters comma separated values');
      }
    });
    if (isValid && areFORuleMappingFareTariffPropertiesOverlapping(gridData)) {
      isValid = false;
    }
    return isValid;
  }
  function validateFORoutingDefinition(gridData) {
    var isValid = true;
    if (areRoutingDefinitionPropertiesDuplicate(gridData)) {
      isValid = false;
      toastr.error('Duplicate row added');
    }
    return isValid;
  }
  function hasInvalidCompetitorAirline(row) {
    return !row.competitorAirline.match(/^[A-Za-z0-9]{2}(,[A-Za-z0-9]{2})*$/);
  }
  function areFORuleMappingFareTariffPropertiesOverlapping(entries) {
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          var isFareSourceFareTypeAirlineCommon = areCommaSeparatedValuesOverlapping(entries[i].fareSource, entries[j].fareSource) && areCommaSeparatedValuesOverlapping(entries[i].fareTypeIndicator, entries[j].fareTypeIndicator) && areCommaSeparatedValuesOverlapping(entries[i].competitorAirline.toLowerCase(), entries[j].competitorAirline.toLowerCase());
          var isCompetitorTariffCommon = areCommaSeparatedValuesOverlapping(entries[i].competitorTariff, entries[j].competitorTariff);
          var isMappedTariffCommon = entries[i].mappedTariff === entries[j].mappedTariff;
          if (isFareSourceFareTypeAirlineCommon && isCompetitorTariffCommon && isMappedTariffCommon) {
            toastr.error('Duplicate row added for fare source, fare type indicator, competitor airline, competitor tariff, mapped tariff');
            return true;
          } else if (isFareSourceFareTypeAirlineCommon && isCompetitorTariffCommon) {
            toastr.error('Duplicate row added for fare source, fare type indicator, competitor airline, competitor tariff');
            return true;
          } else if (isFareSourceFareTypeAirlineCommon && isMappedTariffCommon) {
            toastr.error('Duplicate row added for fare source, fare type indicator, competitor airline, mapped tariff');
            return true;
          }
        }
      }
    }
  }
  function areCommaSeparatedValuesOverlapping(from, to) {
    return _.intersection(_.split(from, ','), _.split(to, ',')).length > 0;
  }
  function areFORuleMappingAPPropertiesOverlapping(entries) {
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          if (areCommaSeparatedValuesOverlapping(entries[i].fareSource, entries[j].fareSource) && areCommaSeparatedValuesOverlapping(entries[i].fareTypeIndicator, entries[j].fareTypeIndicator) && isFORuleMappingAPFiledStartEndOverlapping(entries[i], entries[j]) && entries[i].fareTariffNumber === entries[j].fareTariffNumber) {
            toastr.error('Duplicate row added for fare source, tariff, fare type indicator, filedStart and filedEnd. ');
            return true;
          }
        }
      }
    }
    return false;
  }
  function isFORuleMappingAPFiledStartEndOverlapping(first, second) {
    return first.filedStart === second.fileStart || first.filedEnd === second.filedEnd || _.toNumber(first.filedStart) <= _.toNumber(second.filedEnd) && _.toNumber(second.filedStart) <= _.toNumber(first.filedEnd);
  }
  function validateSurchargeManagement(editedRows, allRows) {
    var isValid = true;
    var columnsToCheck = ['surchargeType', 'fareTariffNumber'];
    _.forEach(editedRows, function (row) {
      if (advancedHepCommonValidationService.isDuplicate(row, allRows, columnsToCheck)) {
        isValid = false;
        toastr.error('Duplicate row added for same surcharge Type and tariff');
      }
    });
    return isValid;
  }
  function validateRbdAssignment(gridData) {
    var isValid = true;
    _.forEach(gridData, function (row) {
      if (!_.isNil(row.hostSeason) && !_.isEmpty(row.hostSeason) && row.hostSeason !== '-') {
        var allowedSeasons = configurationParametersAdvancedService.extractSeasonDetails().seasonsAbbreviation;
        if (!allowedSeasons.includes(row.hostSeason)) {
          isValid = false;
          toastr.error(' Host Season should contain one of the allowed values: -,' + allowedSeasons);
        }
      }
      if ((_.isEmpty(row.hostFareBrand) || _.isNil(row.hostFareBrand)) && !_.isNil(row.competitorFareBrand) && !_.isEmpty(row.competitorFareBrand)) {
        isValid = false;
        toastr.error('Host Fare Brand cannot be empty when Competitor Fare Brand is not empty');
      }
      if (['ENTRY LEVEL RBD', 'RBD TO RBD', 'ORDINAL'].includes(row.rbdMethod) && isFareClassMappingCompetitorFareBrandInvalid(row, row.competitorAirline) || row.rbdMethod === 'FBC MAPPING' && isFareClassMappingCompetitorFareBrandInvalid(row, row.fbcMappingCompetitorAirline)) {
        isValid = false;
        var airline = row.fbcMappingCompetitorAirline ? row.fbcMappingCompetitorAirline : row.competitorAirline;
        toastr.error('Selected competitor fare brands are not applicable for ' + airline);
      }
      if (['ENTRY LEVEL RBD', 'RBD TO RBD'].includes(row.rbdMethod)) {
        var regExp = 'WEB' === row.competitorFareSource.toUpperCase() ? /^[A-Z](,[A-Z])*$|^-$/i : /^[A-Z](,[A-Z])*$/i;
        if (!regExp.test(row.competitorEntryLevelRbd)) {
          isValid = isValid && false;
          toastr.error('Competitor rbd value should be comma separated uppercase alplabets or can be - for web source');
        }
      }
      if (validatePropertiesForRbdToRbdMethod(row) || validatePropertiesForOrdinalRbdMethod(row) || validatePropertiesForFbcMappingRbdMethod(row) || validatePropertiesForOrdinalRbdMethod(row) || validatePropertiesForUpperBoundRbdMethod(row) || validatePropertiesForValueBasedRbdMethod(row)) {
        isValid = isValid && false;
        toastr.error('Based on rbd method corresponding properties should be populated - </br> ' + 'Entry Level/Rbd to Rbd: competitorAirline & competitorEntryLevelRbd;</br>' + 'Ordinal: competitorAirline;</br>' + 'Fbc Mapping: fbcMappingCompetitorAirline & fbcMappingCompetitorFbc;</br>' + 'Upper Bound: upperBoundFbc, upperBoundAmt & typeIndicator;</br>' + 'Value Based: minFare, maxFare & currencyType;');
      }
    });
    var rbdAssignmentKeyValues = _.groupBy(gridData, function (row) {
      return advancedHepCommonValidationService.constructKey(row, AdvancedHepGridConstants.FO_RBD_ASSIGNMENT_KEY_VALUES);
    });
    for (var key1 in rbdAssignmentKeyValues) {
      var groupingByInventoryAssignment = _.groupBy(rbdAssignmentKeyValues[key1], 'rbdMethod');
      if (!_.isEmpty(groupingByInventoryAssignment)) {
        var entries = groupingByInventoryAssignment['ORDINAL'];
        if (isValid && !_.isEmpty(entries) && containsMultipleRowsForOrdinal(entries)) {
          isValid = false;
          toastr.error('For ORDINAL matching, Host RBDs should be same for same fare type, host fare brand and competitor carrier');
        }
      }
    }
    if (isValid && sameFareTypeContainsDifferentBenchmarkingMethod(gridData, 'rbdMethod')) {
      isValid = false;
      toastr.error('Rbd Method should be same for same fare type indicator');
    }
    if (isValid && sameFareTypeContainsDifferentBenchmarkingMethod(gridData, 'ladderMethod')) {
      isValid = false;
      toastr.error('Ladder Generation Method should be same for same fare type indicator');
    }
    var overlappingGroups = getValueBasedOverlappingGroups(gridData);
    if (overlappingGroups.length) {
      isValid = false;
      toastr.error('Overlapping fare ranges are not permitted within the same Host RBD-Source-OWRT-Season-AP-Fare Brand group');
    }
    if (areRbdAssignmentPropertiesDuplicate(gridData)) {
      isValid = false;
      toastr.error('Duplicate row added');
    }
    return isValid;
  }
  function validatePropertiesForRbdToRbdMethod(row) {
    return ['ENTRY LEVEL RBD', 'RBD TO RBD'].includes(row.rbdMethod) && (row.fbcMappingCompetitorAirline || row.fbcMappingCompetitorFbc || row.upperBoundFbc || row.upperBoundAmt || row.typeIndicator || row.minFare || row.maxFare || row.currencyType);
  }
  function validatePropertiesForOrdinalRbdMethod(row) {
    return row.rbdMethod === 'ORDINAL' && (row.competitorEntryLevelRbd || row.fbcMappingCompetitorAirline || row.fbcMappingCompetitorFbc || row.upperBoundFbc || row.upperBoundAmt || row.typeIndicator || row.minFare || row.maxFare || row.currencyType);
  }
  function validatePropertiesForFbcMappingRbdMethod(row) {
    return row.rbdMethod === 'FBC MAPPING' && (row.competitorAirline || row.competitorEntryLevelRbd || row.upperBoundFbc || row.upperBoundAmt || row.typeIndicator || row.minFare || row.maxFare || row.currencyType);
  }
  function validatePropertiesForUpperBoundRbdMethod(row) {
    return row.rbdMethod === 'UPPER BOUND' && (row.competitorAirline || row.competitorEntryLevelRbd || row.fbcMappingCompetitorAirline || row.fbcMappingCompetitorFbc || row.minFare || row.maxFare || row.currencyType);
  }
  function validatePropertiesForValueBasedRbdMethod(row) {
    return row.rbdMethod === 'VALUE BASED' && (row.competitorAirline || row.competitorEntryLevelRbd || row.fbcMappingCompetitorAirline || row.fbcMappingCompetitorFbc || row.upperBoundFbc || row.upperBoundAmt || row.typeIndicator);
  }
  function areRbdAssignmentPropertiesDuplicate(entries) {
    var areFieldsOverlapping = false;
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          var from = entries[i];
          var to = entries[j];
          if (from['rbdMethod'] !== 'VALUE BASED' && checkRbdAssignmentPropertiesDuplicate(from, to)) {
            areFieldsOverlapping = true;
          }
        }
      }
    }
    return areFieldsOverlapping;
  }
  function areRoutingDefinitionPropertiesDuplicate(entries) {
    return entries.length > 1 && entries.some(function (from, i) {
      return entries.slice(i + 1).some(function (to) {
        return checkRoutingDefinitionPropertiesDuplicate(from, to);
      });
    });
  }
  function getValueBasedOverlappingGroups(entries) {
    var overlappingGroups = [];
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          var from = entries[i];
          var to = entries[j];
          if (from['rbdMethod'] === 'VALUE BASED' && areRbdMultiValuedPropertiesDuplicate(from, to) && areRbdSingleValuedPropertiesDuplicate(from, to) && isValueBasedPropertiesOverlapping(from, to)) {
            overlappingGroups.push([from['hostEntryLevelRbd'], from['competitorFareSource'], from['fareTypeIndicator'], from['hostSeason'], from['hostAP']].filter(Boolean).join('.'));
          }
        }
      }
    }
    return (0, _toConsumableArray2["default"])(new Set(overlappingGroups));
  }
  function checkRbdAssignmentPropertiesDuplicate(from, to) {
    return areRbdMultiValuedPropertiesDuplicate(from, to) && areRbdSingleValuedPropertiesDuplicate(from, to) && areRbdCompPropertiesDuplicate(from, to);
  }
  function checkRoutingDefinitionPropertiesDuplicate(from, to) {
    var hasIntersection = function hasIntersection(key) {
      return _.intersection(_.split(getDefaultIfEmptyValues(from, key), ','), _.split(getDefaultIfEmptyValues(to, key), ',')).length > 0;
    };
    return ['fareSource', 'fareTypeIndicator', 'hostFareBrand', 'competitorAirline', 'competitorRouting', 'competitorFbcPattern'].every(hasIntersection) && isFiledAmoundMatchingForRoutingDefiniton(from, to);
  }
  function getDefaultIfEmptyValues(row, key) {
    var isEmpty = function isEmpty(value) {
      return value === null || value === undefined || value === '';
    };
    if (key === 'fareSource') {
      return isEmpty(row[key]) ? 'ATPCO,WEB' : row[key];
    }
    if (key === 'fareTypeIndicator') {
      return isEmpty(row[key]) ? 'OW,RT,OWNC' : row[key];
    }
    return row[key];
  }
  function isFiledAmoundMatchingForRoutingDefiniton(from, to) {
    var isEmpty = function isEmpty(value) {
      return value === null || value === undefined || value === '';
    };
    return isEmpty(from['filedAmount']) ? isEmpty(to['filedAmount']) : isFORuleMappingFiledAmountOverlapping(from, to);
  }
  function areRbdMultiValuedPropertiesDuplicate(from, to) {
    return _.intersection(_.split(from['competitorFareSource'], ','), _.split(to['competitorFareSource'], ',')).length > 0 && _.intersection(_.split(from['fareTypeIndicator'], ','), _.split(to['fareTypeIndicator'], ',')).length > 0 && (from['rbdMethod'] === 'VALUE BASED' || _.intersection(_.split(from['hostEntryLevelRbd'], ','), _.split(to['hostEntryLevelRbd'], ',')).length > 0) && _.intersection(_.split(from['competitorFareBrand'], ','), _.split(to['competitorFareBrand'], ',')).length > 0 && areCommaSeparatedValuesOverlapping(from['hostFareBrand'], to['hostFareBrand']);
  }
  function areRbdSingleValuedPropertiesDuplicate(from, to) {
    return from['hostSeason'] === to['hostSeason'] && from['hostAP'] === to['hostAP'] && from['fareTariffNumber'] === to['fareTariffNumber'];
  }
  function areRbdCompPropertiesDuplicate(from, to) {
    if (['ENTRY LEVEL RBD', 'RBD TO RBD', 'ORDINAL'].includes(from['rbdMethod'])) {
      return from['competitorAirline'] === to['competitorAirline'];
    }
    if (from['rbdMethod'] === 'FBC MAPPING') {
      return from['fbcMappingCompetitorAirline'] === to['fbcMappingCompetitorAirline'];
    }
    if (from['rbdMethod'] === 'UPPER BOUND') {
      return isUpperBoundPropertiesOverlapping(from, to);
    }
    return true;
  }
  function isUpperBoundPropertiesOverlapping(from, to) {
    return from['upperBoundFbc'] === to['upperBoundFbc'] && from['upperBoundAmt'] === to['upperBoundAmt'];
  }
  function isValueBasedPropertiesOverlapping(from, to) {
    return from['minFare'] === to['minFare'] || from['maxFare'] === to['maxFare'] || _.toNumber(from['minFare']) <= _.toNumber(to['maxFare']) && _.toNumber(to['minFare']) <= _.toNumber(from['maxFare']);
  }
  function areModalColumnValidationsFulfilled(editedRows, gridData, type) {
    switch (type) {
      case 'CurtainRule':
        return validateCurtainRuleModal(editedRows, gridData);
      case 'FP_TOD_HubBank':
        return validateTodHubBanksModal(gridData);
      case 'FP_MetroMarket':
        return validateMetroMarketModal(editedRows, gridData);
      case 'FOBusinessRules':
        return validateFOBusinessRulesModal(editedRows, gridData);
      case 'FOTaxOverride':
        return validateFOTaxOverride(editedRows, gridData);
      case 'FOCabinClassConfig':
        return validateFOCabinClassConfig(gridData);
      case 'FOMinStayGrouping':
        return !isPropertiesOverlapped(editedRows, gridData, type);
      case 'FOMaxStayGrouping':
        return !isPropertiesOverlapped(editedRows, gridData, type);
      case 'FOAdvancePurchaseGrouping':
        return !isPropertiesOverlapped(editedRows, gridData, type);
      case 'FORBDLevelFareThreshold':
        return validateFORBDLevelFareThreshold(editedRows, gridData);
      case 'FOFareClassMapping':
        return validateFareClassMapping(editedRows, gridData);
      case 'FOAnalystPosMapping':
        return validateAnalystPosMapping(editedRows, gridData);
      case 'FOSeasonLevelMatchThreshold':
        return validateSeasonLevelMatchThreshold(editedRows, gridData);
      case 'FOFareBrandAssignment':
        return validateFareBrandAssignment(editedRows, gridData);
      case 'FP_MarketConfig':
        return validateMarketConfigModals(editedRows, gridData);
      case 'FOViaPoints':
        return validateRoutingNumberAndViaPoints(editedRows, gridData);
      case 'FOInputDataComparisonChecks':
        return validateInputDataComparisonChecks(editedRows, gridData);
      case 'FOTacticalFareDefinition':
        return validateTacticalFareDefinition(editedRows, gridData);
      case 'DA_FareBrandAssignment':
        return validateFareBrandAssignmentModal(editedRows, gridData);
      case 'FOTacticalFBCPatternConfig':
        return validateTacticalFBCPatternConfig(editedRows, gridData);
      case 'FORuleMappingMaxStay':
        return validateFORuleMappingMaxStay(editedRows, gridData);
      case 'FORuleMappingMinStay':
        return validateFORuleMappingMinStay(editedRows, gridData);
      case 'FORuleMappingDOW':
        return validateFORuleMappingDOW(editedRows, gridData);
      case 'FOApplicableDateMapping':
        return validateApplicableDateMapping(editedRows, gridData);
      case 'FORuleMappingAP':
        return validateFORuleMappingAP(editedRows, gridData);
      case 'FOFareBasisCodePattern':
        return validateFareBasisCodePattern(editedRows, gridData);
      case 'FOSurchargeManagement':
        return validateSurchargeManagement(editedRows, gridData);
      case 'FORbdAssignment':
        return validateRbdAssignment(gridData);
      case 'FORuleMappingFareTariffConfiguration':
        return validateFORuleMappingFareTariff(editedRows, gridData);
      case 'FORoutingDefinition':
        return validateFORoutingDefinition(gridData);
    }
    return true;
  }
  return {
    areModalColumnValidationsFulfilled: areModalColumnValidationsFulfilled,
    validateRbdAssignment: validateRbdAssignment
  };
};
AdvancedHepModalGridValidationService.$inject = ['ConfigurationService', 'AdvancedHepGridConstants', 'FeatureToggleService', 'AdvancedHepCommonValidationService', 'ConfigurationParametersAdvancedService'];
module.exports = AdvancedHepModalGridValidationService;